import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import PairNavButton from '../PairNavButton'
import {
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalContent,
  ModalFooter,
  ModalText,
} from './style'

const PageModal = ({ isOpen, onClose, data }) => {
  const {
    title,
    content,
    leftButton,
    leftButtonFunc,
    leftButtonLabel,
    rightButton,
    rightButtonFunc,
    rightButtonLabel,
    isModalBtn,
  } = data
  const [isVisible, setIsVisible] = useState(false)
  const closeBtn = useRef(null)
  if (isOpen && !isVisible) {
    setIsVisible(true)
    setTimeout(() => closeBtn.current.focus(), 300)
  }
  if (!isOpen && isVisible) {
    setTimeout(() => setIsVisible(false), 600)
  }
  const ariaDescription =
    title && title.includes('Account')
      ? `modal-${title}`
      : 'modal-cancel-process'
  return (
    <ModalContainer
      aria-hidden={!isOpen}
      isVisible={isVisible}
      role="modal"
      aria-describedby={ariaDescription}
      aria-live={isVisible ? 'polite' : null}
    >
      <ModalHeader id="modal-header">
        <ModalTitle id="modal-title" tabindex="0">
          {title}{' '}
        </ModalTitle>
        <CloseButton
          onClick={onClose}
          id="modalCloseButton"
          aria-label="modal close button, to close modal double click here"
          ref={closeBtn}
        ></CloseButton>
      </ModalHeader>
      <ModalContent id="modal-content">
        {content &&
          content.map((item, index) => (
            <ModalText key={index}>{item}</ModalText>
          ))}
      </ModalContent>
      {leftButton && (
        <ModalFooter id="modal-nav-button">
          <PairNavButton
            leftButton={leftButton}
            leftButtonFunc={leftButtonFunc}
            leftButtonLabel={leftButtonLabel}
            rightButton={rightButton}
            rightButtonFunc={rightButtonFunc}
            rightButtonLabel={rightButtonLabel}
            isModalBtn={isModalBtn === false ? isModalBtn : true}
          />
        </ModalFooter>
      )}
    </ModalContainer>
  )
}

PageModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.object,
}

export default PageModal
